export default __webpack_public_path__ + "static/media/Horse.c1ad31ff.png";